import { useMutation, useQueryClient } from '@tanstack/react-query';
import { trasladar, type EntradaTraslado } from '../lib/api/traslados';
import { invalidarStock } from './keys';

export function useTrasladar() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: EntradaTraslado) => trasladar(input),
    onSuccess: () => invalidarStock(qc),
  });
}
